import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Profile from './pages/Profile';
import EditCard from './pages/EditCard';
import Settings from './pages/Settings';
import NotFound from './pages/NotFound';
import Notification from './components/Notification';
import './styles/global.css';

function App() {
  return (
    <Router>
      <div className="app">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/profile/:id" element={<Profile />} />
          <Route path="/add" element={<EditCard />} />
          <Route path="/edit/:id" element={<EditCard />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Notification />
      </div>
    </Router>
  );
}

export default App;
